export { AppPermissions, type Permission } from "./AppPermissions"
import type { Permission } from "./AppPermissions"

export type PermissionRule =
	| Permission
	| Permission[]
	| { any: Permission[] }
	| { all: Permission[] }

export function matchesPermission(granted: ReadonlySet<Permission>, needle: Permission): boolean {
	if (granted.has(needle)) return true
	if (needle.endsWith('.*')) {
		const prefix = needle.slice(0, -1)
		for (const p of granted) if (p.startsWith(prefix)) return true
		return false
	}
	for (const p of granted) {
		if (p === needle) return true
		if (p.endsWith('.*') && needle.startsWith(p.slice(0, -1))) return true
	}
	return false
}

export function evaluateRule(granted: ReadonlySet<Permission>, rule: PermissionRule | undefined): boolean {
	if (rule === undefined || rule === null) return true
	if (typeof rule === 'string') return matchesPermission(granted, rule)
	if (Array.isArray(rule)) return rule.every(p => matchesPermission(granted, p))
	if ('any' in rule) return rule.any.some(p => matchesPermission(granted, p))
	if ('all' in rule) return rule.all.every(p => matchesPermission(granted, p))
	return false
}
